<template>

  <div class="com-logout" v-if="showCancel" v-loading="formLoading">
    <img class="e-img" :src="require('@/assets/images/error.png')" alt="">
    <div class="tishi">该用户已注销！</div>
<!--    <router-link to="/" class="go-index"><i class="el-icon-back"></i> 返回首页</router-link>-->
    <a href="http://www.renrendonghua.com" class="go-index"><i class="el-icon-back"></i> 返回首页</a>
  </div>
  <div class="page-home" :key="userId" v-loading="formLoading" v-else-if="showInfo">
    <div
      class="person-bg"
      :style="{ backgroundImage: 'url(' + homepageBanner + ')' }"
    >
      <div class="mask-bg"></div>
      <div class="edit-bg" v-if="userId == currentUserId">
        <label
          ><input
            type="file"
            @change="addImg($event)"
            ref="inputer"
            accept="image/png,image/jpeg,image/jpg"
            class="ipt-upload"
          /><i class="el-icon-edit-outline"></i>编辑封面图片</label
        >
      </div>
      <div class="much-count">
        <router-link
          class="user"
          :to="{ path: '/home/fensi', query: { userId: userId } }"
        >
          <div class="count">
            <span class="type">粉丝</span>
            <span class="much">{{ userInfo.followersCount }}</span>
          </div>
        </router-link>
        <router-link
          class="user"
          :to="{ path: '/home/guanzhu', query: { userId: userId } }"
        >
          <div class="count">
            <span class="type">关注</span>
            <span class="much">{{ userInfo.followingsCount }}</span>
          </div>
        </router-link>
        <div class="user-avatar"></div>
        <div class="count">
          <span class="type">访客</span>
          <span class="much">{{ userInfo.userVistorCount }}</span>
        </div>
        <router-link
                class="user"
                :to="{ path: '/home/rankdetail', query: { userId: userId } }"
        >
        <div class="count">
          <span class="type">影响力</span>
          <span class="much">{{userInfo.influenceValue}}</span>
        </div>
        </router-link>
      </div>
    </div>
    <div class="user-info">
      <div class="content">
        <div class="avatar-f">
          <img
            :src="`http://iss.21teacher.com/avatar/125/${userId}/20.jpg`"
            alt=""
          />
          <div class="mask" @click="showUploadImg" v-if="isSelf">
            <i class="el-icon-camera-solid"></i>
            <span>修改我的头像</span>
          </div>
        </div>
        <!-- <div class="user-name">{{userInfo.userName}}</div> -->
        <div class="set-name">
          <div class="cont-name">
            <input
              @blur="changeName(0)"
              ref="nameinput"
              class="center-name"
              :class="{ active: contenteditable }"
              v-model="infoes.userName"
              :disabled="!contenteditable"
            />
            <span class="change-name" v-if="isSelf" @click="changeName(1)">
              <i class="icon"></i
              >{{ contenteditable === false ? "修改" : "确定" }}
            </span>
          </div>
        </div>
        <!--                <div class="user-title">{{userInfo.userRankName}}</div>-->
        <div
          class="new-chenghao clearfix"
          v-if="userInfo.userRankName != '' && userInfo.userRankName != null"
        >
          <i
            class="icon zs"
            v-if="userInfo.userRankName.split(',')[1] == '资深作者'"
          ></i>
          <i
            class="icon yx"
            v-if="userInfo.userRankName.split(',')[1] == '优秀作者'"
          ></i>
          <i
            class="icon hy"
            v-if="userInfo.userRankName.split(',')[1] == '活跃作者'"
          ></i>
          <span class="zuoz">{{ userInfo.userRankName.split(",")[1] }}</span>
          <span class="shu">|</span>
          <span class="liny">{{ userInfo.userRankName.split(",")[0] }}</span>
        </div>

        <!-- 个性签名 -->
        <div class="user-gxname">
          个性签名：{{
            infoes.signature == "" ? "用户尚未填写资料" : infoes.signature
          }}
          <span
            class="change-words"
            v-if="isSelf"
            @click="qmChangeWordsEvent(1)"
            >{{ qmChangeWordsShow === false ? "修改" : "确定" }}</span
          >
        </div>
        <el-input
          ref="nameinput1"
          @input="checkLength(1)"
          @blur="qmChangeWordsEvent(0)"
          class="cons-ipt-n"
          placeholder="请输入个性签名"
          v-if="qmChangeWordsShow === true"
          v-model="infoes.signature"
        ></el-input>
        <!-- 擅长领域 -->
        <div class="user-speciality">
          擅长领域：{{
            infoes.introduction == "" ? "用户尚未填写资料" : infoes.introduction
          }}
          <span
            class="change-words"
            v-if="isSelf"
            @click="lyChangeWordsEvent(1)"
            >{{ lyChangeWordsShow === false ? "修改" : "确定" }}</span
          >
        </div>
        <el-input
          ref="nameinput2"
          @input="checkLength(2)"
          @blur="lyChangeWordsEvent(0)"
          class="cons-ipt-n"
          placeholder="请输入擅长领域"
          v-if="lyChangeWordsShow === true"
          v-model="infoes.introduction"
        ></el-input>
        <div style="margin-top: 10px;">
          <el-button
            class="btn wgz-btn"
            v-if="followStatus == 0"
            @click="follower()"
            ><i class="el-icon-plus"></i> 关注</el-button
          >
          <el-button
            class="btn"
            v-if="followStatus == 2"
            @click="undoFollower()"
            >互相关注</el-button
          >
          <el-button
            class="btn"
            v-if="followStatus == 1"
            @click="undoFollower()"
            >已关注</el-button
          >

          <el-button
            class="btn wgz-btn"
            v-if="friendStatus == 4"
            @click="addFriend()"
            ><i class="el-icon-plus"></i> 加好友</el-button
          >
          <!--<el-button
            class="btn"
            @click="toChart(userInfo.userId)"
            v-else-if="friendStatus == 2"
            >发消息</el-button
          >-->
          <el-button
            class="btn"
            v-else-if="friendStatus == 1"
            style="cursor:auto"
            >请求中</el-button
          >
        </div>
      </div>
    </div>
    <div class="common-type-list">
      <router-link
        class="type-item"
        v-for="(item, index) in contTabs.slice(0, 5)"
        :key="index"
        :to="{ path: item.path, query: { userId: userId } }"
      >
        {{ item.tit }}
      </router-link>
      <el-dropdown>
        <span class="type-item" :class="{ 'router-link-active': isMore }"
          >更多</span
        >
        <el-dropdown-menu slot="dropdown">
          <router-link
            v-for="(item, index) in contTabs.slice(5)"
            :key="index"
            :to="item.path + '?userId=' + userId"
          >
            <el-dropdown-item v-if="isShow && index == 0">{{
              item.tit
            }}</el-dropdown-item>
            <el-dropdown-item v-if="index != 0">{{
              item.tit
            }}</el-dropdown-item>
          </router-link>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="types-cont">
      <router-view></router-view>
    </div>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="上传图片"
      :visible.sync="dialogUploadImg"
      top="100px"
      :width="$store.state.app.device === 'desktop' ? '500px' : '90%'"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <div class="cut-img" v-loading="imageLoading">
        <div class="cropper-wrap-f">
          <div class="cropper-wrap">
            <vue-cropper
              ref="cropper"
              :img="option.img"
              :fixed="option.fixed"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :outputType="option.outputType"
              mode="cover"
            >
            </vue-cropper>
          </div>
        </div>
        <div class="btns">
          <label class="btn"
            ><input
              type="file"
              id="uploads"
              style="position:absolute; clip:rect(0 0 0 0);"
              accept="image/png, image/jpeg, image/gif, image/jpg"
              @change="uploadImg($event)"
            />{{ option.img === "" ? "上传" : "重新选择" }}图片</label
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="isSelf">
        <el-button type="primary" @click="setAvatar">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
//import {VueCropper} from 'vue-cropper'
import homeApi from '@/api/home'
import utilAPi from '@/api/util'
import axios from 'axios';
import vue from 'vue';
import userApi from '@/api/user'
vue.prototype.$axios = axios;
import qs from 'qs';
export default {
  components: {
    //VueCropper
  },
  data() {
    return {
      showCancel:false,
      showInfo:false,
      loading:true,
      followStatus:-1,
      friendStatus:-1,
      form: {
        id:0,
        nickName:'',
        name: '',
        email: '',
      },
      oldSignature:"",
      oldIntroduction:"",
      homepageBanner: "",
      formLoading: true,
      userId: 0,
      imageLoading:false,
      currentUserId: 0,
      contTabIndex: 0,
      contTabs: [
        {
          tit: '动态',
          path: '/home/dongtai'
        },
        {
          tit: '活动',
          path: '/home/huodong'
        },
        {
          tit: '作品',
          path: '/home/zuopin'
        },
        {
          tit: '专栏',
          path: '/home/wenzhang'
        },
        {
          tit: '收藏',
          path: '/home/shoucang'
        },
        {
          tit: '好友',
          path: '/home/haoyou'
        },
        {
          tit: '粉丝',
          path: '/home/fensi'
        },
        {
          tit: '关注',
          path: '/home/guanzhu'
        },
        {
          tit: '我的标签',
          path: '/home/biaoqian'
        },
        // {
        //     tit: '好友评价',
        //     path: '/home/pingjia'
        // },
        {
          tit: '好友印象',
          path: '/home/yinxiang'
        },
        {
          tit: '个人资料',
          path: '/home/ziliao'
        },
      ],
      userInfo: {
      },
      dialogUploadImg: false,
      option: {
        img: '', // require('./cropper.jpg')
        fixed: true, // 是否开启截图框宽高固定比例
        autoCrop: true, // 是否显示截图框
        autoCropWidth: 450, // 截图框默认宽度
        autoCropHeight: 450, // 截图框默认高度
        outputType: 'jpeg' // 图片输出格式
      },
      infoes: {

      },
      contenteditable: false,
      qmChangeWordsShow: false,
      lyChangeWordsShow: false,
      isSelf:false,
      isShow:false
    }
  },
  computed: {
    isMore () {
      let routePath = this.$route.path
      if(
              routePath === '/home/haoyou' ||
              routePath === '/home/fensi' ||
              routePath === '/home/guanzhu' ||
              routePath === '/home/biaoqian' ||
              routePath === '/home/pingjia' ||
              routePath === '/home/yinxiang' ||
              routePath === '/home/ziliao'
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    '$route': function (newUrl, oldUrl) {
      if (newUrl != oldUrl) {
        this.userId = this.$route.query.userId;
        //console.log("watch个人中心userId=" + this.userId)
        if (this.global.userModel != null) {
          this.currentUserId = this.global.userModel.id
        }
       // console.log("watch个人中心currentUserId=" + this.currentUserId)
        //console.log("watch个人中心userId=" + this.userId)
        if(this.userId == undefined){
          return ;
        }

        this.getUserInfo()

        if(this.userId == this.currentUserId){
          this.contTabs[8].tit = '我的标签'
          this.isShow = true
        }else{
          this.contTabs[8].tit = '他的标签'
          this.isShow = false
        }
      }
    }
  },
  beforeMount() {
    // 只会在浏览器执行Z import {VueCropper} from 'vue-cropper'
   // const VueCropper = () => import('vue-cropper')
    let thiss =this
    const VueCropperBak = () => import("vue-cropper")
    VueCropperBak().then(res =>{
      thiss.$options.components.VueCropper = res.default.VueCropper
    })
  },
  mounted() {

    setTimeout(()=>{
      let _this = this
      let id = _this.$route.query.userId
     // console.log("个人中心userId=" + id)
      if (_this.global.userModel != null) {
        _this.currentUserId = _this.global.userModel.id
      }
      //console.log("个人中心currentUserId=" + this.currentUserId)
      //console.log("个人中心id=" + this.id)
      if(id == this.currentUserId){
        this.contTabs[8].tit = '我的标签'
        this.isShow = true
      }else{
        this.contTabs[8].tit = '他的标签'
        this.isShow = false
      }
      _this.userId = id
      _this.getUserInfo();

    },500)

  },
  methods: {
    getImpressForUser(userId){
      let _this = this
      let url="/rrbi/impress/userSelect?userId="+userId+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        let impressStr = "";
        result.data.response.forEach((item,index) => {
          if(index < result.data.response.length-1){
            impressStr += "{" + item.impressName+ "},"
          }else{
            impressStr += "{" + item.impressName+ "}"
          }
          document.querySelector('meta[name="keywords"]').setAttribute('content', impressStr)
        })
      })
    },
    vistor(){
      homeApi.userPageVistor(this.userId).then(data => {

      });
    },
    getUserInfo() {
      this.formLoading = true;
      if(this.userId == undefined){
        return ;
      }
      homeApi.getUserInfo(this.userId).then(data => {
        // console.log(data)
        if (data.code) {
          this.userInfo = data.response
          if(this.userInfo.isCancelApply == 1 || this.userInfo.isCancelApply== 2){
            this.showCancel = true;
          }else{
            this.showInfo = true;
          }
          // console.log("this.userInfo",this.userInfo)
          //.log("123123",this.infoes.introduction)
          if(this.infoes.introduction==null||this.infoes.introduction==undefined){
            this.infoes.introduction='';
            this.oldIntroduction=""
          }else{

            this.oldIntroduction=this.infoes.introduction
          }
          if(this.infoes.signature==null||this.infoes.signature==undefined){
            this.infoes.signature='';
            this.oldSignature=""
          }else{
            this.oldSignature=this.infoes.signature
          }
          if(this.userInfo.homepageBanner != null && this.userInfo.homepageBanner != ""){
            this.homepageBanner = this.userInfo.homepageBanner
          }else{
            this.homepageBanner = require('@/assets/images/home_bg.jpg')
          }
          this.formLoading = false;
          this.getImpressForUser(this.userId)
          this.vistor();
          this.getUserInfomation()
          this.getFollowStatus()
          this.getFriendStatus()
        }else{
          this.showInfo = true;
        }
      })
    },
    getUserInfomation(){
      let _this=this;
      // _this.fullscreenLoading = true
      let url="/rrbi/userInfo/userInfo-one?userId="+this.userId+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        //console.log(result.data.response)
        _this.infoes=result.data.response;
        _this.isSelf=result.data.response.isSelf;
        // _this.fullscreenLoading = false
      })
    },
    showUploadImg () {
      this.dialogUploadImg = true
    },
    uploadImg (e) {
      //上传图片
      var file = e.target.files[0]
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
        return false
      }
      var reader = new FileReader()
      reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }

        this.option.img = data
      }
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file)
    },
    cutOver () {
      this.dialogUploadImg = false
      // 输出bolb格式地址
      this.$refs.cropper.getCropBlob((data) => {
        var img = window.URL.createObjectURL(data)
       // console.log(img);
      })
      // 输出base64格式
      this.$refs.cropper.getCropData((data) => {
        //console.log(data);
      })
    },
    uploadBase64File(base64Data){
      var _this = this
      // var url = "/avatar/base64Upload";

      let postData = {base64Data:base64Data,appid:125,userid:_this.userId}


      userApi.updateImg(postData).then(data => {
        if(data.code ===1){
          let data1={
            userId:_this.userId,
          }
          let url="/rrbi/privacy/privacy-updateByUserId?tem="+new Date().getMilliseconds();
          this.$axios.post(url,qs.stringify(data1)).then(function (result1) {
            // console.log(result1)
          })
          this.$message.success("更新成功，即将刷新页面")
          this.imageLoading=false
          this.dialogUploadImg = false
          this.timer = setTimeout(()=>{   //设置延迟执行
            window.location.reload()
          },1000);

        }else{
          _this.$message.error(data.message)
        }
        _this.formLoading = false
      })

      /*
      axios.post(url,_this.qs.stringify(postData)).then((res) => {
        //console.log("上传成功");
        window.location.reload()
        _this.formLoading = false
      }).catch(e => {
        _this.formLoading = false
      })

/*
      axios.post(url,_this.qs.stringify(postData)).then((res) => {
        console.log("上传成功",res.data);
        if(res.result != 3){
          console.log("上传成功");
        }else{
          console.log("上传失败");
        }
        _this.formLoading = false
      }).catch(e => {
        _this.formLoading = false
      })

 */
    },
    // changeName () {
    //     if (this.contenteditable === false) {
    //         this.contenteditable = true
    //         this.$nextTick(function () {
    //             this.$refs.nameinput.select()
    //         })
    //     } else {
    //         this.contenteditable = false
    //         console.log(this.userInfo.userName)
    //     }
    // },
    changeName (type) {

      if (this.contenteditable === false) {
        this.contenteditable = true
        this.$nextTick(function () {
          this.$refs.nameinput.select()
        })
      } else if(type==0){
        // this.contenteditable = false
        //console.log(this.infoes.userName)
        let _this=this;
        _this.formLoading = true;
        let url="/rrbi/userInfo/userInfo-update";
        // eslint-disable-next-line no-unused-vars
        _this.$axios.post(url, _this.infoes).then(function(result){
          let url1 ="/rrbi/userInfo/userInfo-updateOther";
          _this.$axios.post(url1, _this.infoes).then(function(result1){
            console.log(result1)
          })
          // _this.infoes=result.data.response;
          _this.form.id=_this.infoes.userId
          // _this.form.name=_this.infoes.realName
          _this.form.nickName=_this.infoes.userName
          _this.form.name=_this.infoes.userName
          _this.form.email=_this.infoes.contactEmail
          // eslint-disable-next-line no-unused-vars
          userApi.update(_this.form).then(data => {
            _this.$message.success("更新成功，即将刷新页面")
            _this.timer = setTimeout(()=>{   //设置延迟执行
              window.location.reload()
            },1000);
          })

        })
      }
    },
    qmChangeWordsEvent (type) {
      if (this.qmChangeWordsShow === false&&type==1) {
        this.qmChangeWordsShow = true
        this.$nextTick(function () {
          this.$refs.nameinput1.select()
        })
      }else {
        if(type===0) {
          //console.log(this.userInfo.signature)
          this.setUseInfo()
          // this.qmChangeWordsShow = false
        }
      }
    },
    lyChangeWordsEvent (type) {
      if (this.lyChangeWordsShow === false&&type==1) {
        this.lyChangeWordsShow = true
        this.$nextTick(function () {
          this.$refs.nameinput2.select()
        })
      }else {
        if(type===0){
          //console.log(this.userInfo.introduction)
          this.setUseInfo()
          // this.lyChangeWordsShow = false
        }

      }
    },
    checkLength(type){

      let oldStr="";
      let str="";
      if(type==1){
        oldStr=this.oldSignature;
        str=this.infoes.signature;
      }else{
        oldStr=this.oldIntroduction;
        str=this.infoes.introduction;
      }
      let strs=str.split('');
      let strLength=0;
      let re=/[^\u4e00-\u9fa5]/;
      strs.forEach(function (e) {
        if(!re.test(e)){
          strLength=strLength+2
        }else{
          strLength=strLength+1
        }
      })
      if(strLength>24){
        if(type==1) {
          this.infoes.signature = oldStr;
        }else{
          this.infoes.introduction = oldStr;
        }
      }else{
        if(type==1) {
          this.infoes.signature=str;
          this.oldSignature=this.infoes.signature;
        }else{
          this.infoes.introduction=str;
          this.oldIntroduction=this.infoes.introduction;
        }

      }
      // return strLength;
    },
    setUseInfo(){
      let _this=this;
      let url="/rrbi/userInfo/userInfo-update";
      //console.log(_this.infoes)
      // if(_this.checkLength(_this.infoes.signature)>24){
      //     this.$message.error("个性签名中文字符长度x2加非中文字符长度不能大于24")
      //     return false;
      // }
      // if(_this.checkLength(_this.infoes.introduction)>24){
      //     this.$message.error("擅长领域中文字符长度x2加非中文字符长度不能大于24")
      //     return false;
      // }
      // eslint-disable-next-line no-unused-vars
      _this.$axios.post(url, _this.infoes).then(function(result){

        // _this.form.id=_this.infoes.userId
        // // _this.form.name=_this.infoes.realName
        // _this.form.nickname=_this.infoes.userName
        // _this.form.name=_this.infoes.userName
        // _this.form.email=_this.infoes.contactEmail
        // userApi.update(_this.form).then(data => {
        _this.$message.success("更新成功，即将刷新页面")
        _this.timer = setTimeout(()=>{   //设置延迟执行
          window.location.reload()
        },1000);
        // })
        // _this.infoes=result.data.response;
      })
    },
    setAvatar () {
      this.imageLoading = true
      // 输出bolb格式地址
      let this_ = this
      /*
      this_.$refs.cropper.getCropBlob((data) => {
        var img = window.URL.createObjectURL(data)
        console.log("输出bolb格式地址==",img);
      })
*/
      // 输出base64格式
      this_.$refs.cropper.getCropData((data) => {
        //console.log("输出base64格式==",data);
        this_.uploadBase64File(data)
      })
    },
    addImg(event){
      var that = this;
      var inputDOM = that.$refs.inputer;
      var file = inputDOM.files[0];
      if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(event.target.value)) {
        that.$message.error('图片类型必须是jpeg,jpg,png')
        return false
      }

      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        that.$message.error('图片大小不能超过 5MB!')
        return false
      }
      that.formLoading = true
      const formData = new FormData() // 创建form对象
      formData.append('file', file)// 通过append向form对象添加数据
      formData.append('uid', file.uid)// 通过append向form对象添加数据
      utilAPi.uploadImg(formData).then(data => {
        console.log("上传成功",data);
        that.formLoading = false
        that.$axios.post("/rrbi/userInfo/userInfo-update",
                {homepageBanner:data.url,userId:that.userId,id:that.userInfo.id}).then(function(re){
          if(re.data.code == 1){
            that.homepageBanner = data.url
          }

        })

      }).catch(e =>{
        console.log(e)
        that.formLoading = false
      })
    },
    getFollowStatus(){
      let _this=this;
      let url="/rrbi/follow/getFollowStatus?userId="+_this.userId+"&currentUserId="+_this.currentUserId+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        _this.followStatus = result.data
      })
    },
    follower() {
      let _this = this;
      homeApi.follower(_this.userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status != -1) {
          _this.followStatus = status
          _this.$message.success("关注成功")
        } else {
          _this.$message.error("关注失败")
        }
      })
    },
    undoFollower() {
      let _this = this;
      homeApi.undoFollower(_this.userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status == 1) {
          _this.followStatus = 0
          _this.$message.success("取消成功")
        } else {
          _this.$message.error("取消失败")
        }
      })
    },
    getFriendStatus(){
      let _this=this;
      let url="/rrbi/friends/getFriendStatus?userId="+_this.userId+"&currentUserId="+_this.currentUserId+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        _this.friendStatus = result.data
      })
    },
    addFriend() {
      let _this = this;
      if (_this.global.isLogin) {
        let url = '/rrbi/friends/add/' + _this.userId + "?ti=" + new Date().getMilliseconds();
        _this.$axios.get(url).then(function (result) {
          console.log(result)
          if (result.data.response.code == 1) {
            _this.$message.success(result.data.response.msg)
            _this.friendStatus = 1
          } else {
            _this.$message.error(result.data.response.msg)
          }
        })
      }
    },
  }
}
</script>

<style scoped lang="less">
.page-home {
  padding-top: @NAVHEIGHT;
}

// bg
.person-bg {
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  .mask-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
  }

  .edit-bg {
    position: absolute;
    color: #fff;
    text-align: right;
    font-size: 14px;

    label {
      cursor: pointer;

      .ipt-upload {
        display: none;
      }

      i {
        margin-right: 5px;
        font-size: 16px;
      }
    }
  }

  .much-count {
    position: absolute;
    bottom: 0;

    .count {
      float: left;
      padding-top: 30px;
      width: 20%;
      height: 100px;
      color: #fff;
      text-align: center;

      .type {
        display: block;
        color: #efefef;
        font-size: 14px;
      }

      .much {
        margin-top: 10px;
        display: block;
        font-size: 24px;
      }
    }

    .user-avatar {
      float: left;
      width: 20%;
      height: 100px;
    }

    &:before,
    &:after {
      position: absolute;
      bottom: 30px;
      content: "";
      display: block;
      width: 1px;
      height: 30px;
      background: #fff;
    }

    &:before {
      left: 20%;
    }

    &:after {
      right: 20%;
    }
  }
}

// user info
.user-info {
  width: 100%;
  background: #fff;

  .avatar-f {
    position: relative;
    overflow: hidden;
    margin: 0 auto;
    border-radius: 50%;
    border: 4px solid #fff;

    img {
      width: 100%;
    }
    .mask {
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      color: #fff;
      background: rgba(0, 0, 0, 0.3);
      cursor: pointer;
      transition: opacity 0.3s;
      i {
        font-size: 50px;
      }
      span {
        margin-top: 5px;
        font-size: 14px;
      }
    }
    &:hover {
      .mask {
        opacity: 1;
      }
    }
  }

  .content {
    margin: 0 auto;
    text-align: center;

    .user-name {
      color: #000;
      font-size: 24px;
    }
    .set-name {
      margin-top: 5px;
      text-align: center;
      .cont-name {
        position: relative;
        display: inline-block;
        .center-name {
          padding: 4px 5px;
          width: 200px;
          line-height: 25px;
          font-size: 18px;
          text-align: center;
          color: #4c4c4c;
          font-weight: bold;
          background: none;
          &.active {
            background: #f5f5f5;
            outline: #1a79e4 solid 1px;
          }
        }
        .change-name {
          position: absolute;
          left: 100%;
          top: 9px;
          margin-left: 5px;
          display: flex;
          align-items: center;
          width: 50px;
          font-size: 12px;
          line-height: 15px;
          color: #1a79e4;
          cursor: pointer;
          opacity: 0.3;
          transition: opacity 0.3s;
          &:hover {
            opacity: 1;
          }
          .icon {
            margin-right: 2px;
            display: block;
            width: 15px;
            height: 15px;
            background-image: url("../../assets/images/icon_change_name.png");
          }
        }
      }
    }
    .user-title,
    .user-gxname,
    .user-speciality {
      margin-top: 4px;
      color: #b2b2b2;
      font-size: 14px;
      .change-words {
        margin-left: 20px;
        padding-left: 15px;
        color: #1a79e4;
        font-size: 12px;
        background-image: url("../../assets/images/icon_change_name.png");
        background-repeat: no-repeat;
        background-size: auto 100%;
        cursor: pointer;
        opacity: 0.3;
        transition: opacity 0.3s;
        &:hover {
          opacity: 1;
        }
      }
    }
    .cons-ipt-n {
      margin: 0 auto 10px;
      width: 500px;
      /deep/input {
        text-align: center;
      }
    }
    .user-title {
      margin-top: 0;
    }
    .user-gxname {
      margin-top: 20px;
    }
  }
}

//
.types-cont {
  margin: 40px auto;

  /deep/.cont-dongtai,
      // .cont-zuopin,
      // .cont-shoucang,
    .cont-fensi,
    .cont-guanzhu {
    background: #fff;
  }
  .cont-fensi,
  .cont-guanzhu,
  .have-tit {
    position: relative;
    /deep/.user-much-num {
      position: absolute;
      top: -40px;
      left: 10px;
      line-height: 40px;
      font-size: 14px;
      color: #666;
    }
  }
}
// 裁剪缩略图
.cut-img {
  .cropper-wrap-f {
    position: relative;
    padding-bottom: 100%;
    width: 100%;
    height: 0;
    .cropper-wrap {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
  .btns {
    margin-top: 20px;
    text-align: center;
    .btn {
      display: inline-block;
      width: 100%;
      line-height: 32px;
      color: #fff;
      font-size: 12px;
      background: #4e90ff;
      border-radius: 4px;
      cursor: pointer;
      box-sizing: border-box;
      &:hover {
        background: rgb(64, 158, 255);
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .types-cont {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 100%;
    .cont-fensi,
    .cont-guanzhu,
    .have-tit {
      /deep/.user-much-num {
        top: -20px;
        line-height: 20px;
        font-size: 12px;
      }
    }
  }
}

@media screen and (min-width: 751px) {
  .types-cont {
    width: 700px;
  }
}

@media screen and (max-width: 1023px) {
  .person-bg {
    height: 200px;

    .edit-bg {
      top: 10px;
      right: 10px;
    }

    .much-count {
      width: 100%;

      &:before,
      &:after {
        bottom: 10px;
      }

      .count {
        padding-top: 5px;
        height: 50px;
        line-height: 20px;

        .type {
          font-size: 12px;
        }

        .much {
          margin-top: 0;
          font-size: 14px;
        }
      }

      .user-avatar {
        height: 50px;
      }
    }
  }

  .user-info {
    padding-bottom: 10px;

    .content {
      margin-top: -7vw;
      padding: 0 10px;
      width: 100%;

      .avatar-f {
        width: 14vw;
        height: 14vw;
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  .person-bg {
    height: 350px;

    .edit-bg {
      top: 50px;
    }

    .edit-bg,
    .much-count {
      left: 50%;
      margin-left: -500px;
      width: 1000px;
    }
  }

  .user-info {
    padding-bottom: 20px;

    .content {
      margin-top: -70px;
      width: 1000px;

      .avatar-f {
        width: 140px;
        height: 140px;
      }
    }
  }

  .types-cont {
    width: 1000px;
  }
}

@media screen and (min-width: 1250px) {
  .types-cont {
    width: 1200px;
  }
}
.com-logout {
    padding-top: @NAVHEIGHT;
  padding-bottom: 10vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 60vh;
  .e-img{
    max-width: 100%
  }
  .tishi{
    color: #666;
    font-size: 14px;
  }
  .go-index{
    margin-top: 5px;
    color: #409eff;
    font-size: 14px;
  }
}
//@import "../../assets/less/stylePublic.less";
</style>
